import React, { useEffect, useRef } from 'react';

/**
 * Toast fijo abajo a la derecha. Auto-cierra tras `durationMs` (0 = sin auto-cierre).
 */
const AppToast = ({ message, variant = 'success', onClose, durationMs = 5200 }) => {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!message?.trim()) return undefined;
    if (durationMs <= 0) return undefined;
    const id = window.setTimeout(() => onCloseRef.current?.(), durationMs);
    return () => window.clearTimeout(id);
  }, [message, durationMs]);

  if (!message?.trim()) return null;

  const isError = variant === 'error';
  const box = isError
    ? 'border-red-200/90 bg-red-50 text-red-900'
    : 'border-emerald-200/90 bg-emerald-50 text-emerald-900';
  const btn = isError ? 'text-red-800/70 hover:bg-red-100/80 hover:text-red-950' : 'text-emerald-800/70 hover:bg-emerald-100/80 hover:text-emerald-950';

  return (
    <div
      role={isError ? 'alert' : 'status'}
      aria-live={isError ? 'assertive' : 'polite'}
      className={`fixed z-[70] max-w-[min(22rem,calc(100vw-2rem))] bottom-4 right-4 sm:bottom-6 sm:right-6 rounded-xl border px-4 py-3 text-sm font-medium shadow-lg flex items-start gap-2 ${box}`}
    >
      <span className="flex-1 min-w-0 leading-snug pr-1">{message}</span>
      <button
        type="button"
        className={`shrink-0 -mr-1 -mt-0.5 rounded-lg p-1 leading-none ${btn}`}
        onClick={() => onCloseRef.current?.()}
        aria-label="Cerrar aviso"
      >
        ×
      </button>
    </div>
  );
};

export default AppToast;
